export enum HeaderImageType {
	DEFAULT = "np_beach-sunset_305290_FFFFFF.svg",
	DMV = "header-image-car.svg",
	PROPERTY_TAX = "header-image-house.svg",
	BUSINESS_TAX = "header-image-business.svg"
}
